export default __webpack_public_path__ + "static/media/day_book_.e6fc9467.xlsx";